module.exports = __webpack_public_path__ + "static/media/icn-chevron-left.4f08b941.svg";